export enum AnalyticsEvent {
  OnboardingSignInViewed = "onboardingSignInViewed",
  OnboardingOfferViewed = "onboardingOfferViewed",
  OnboardingOfferSkipped = "onboardingOfferSkipped",
  CheckoutStarted = "checkoutStarted",
  /** The discounted offer shown when a buyer leaves the checkout unpaid. */
  CheckoutAbandonOfferViewed = "checkoutAbandonOfferViewed",
  SummaryRequested = "summaryRequested",
  SummaryCompleted = "summaryCompleted",
  CommentsRequested = "commentsRequested",
  CommentsCompleted = "commentsCompleted",
  ChatMessageSent = "chatMessageSent",
  InsightAudioPlayed = "insightAudioPlayed",
  FreeQuotaHit = "freeQuotaHit",
  ChromeReviewPromptShown = "chromeReviewPromptShown",
  PublicSummaryViewed = "publicSummaryViewed",
  PublicSummarySaveClicked = "publicSummarySaveClicked",
  InsightCardPosted = "insightCardPosted",
  SummaryShared = "summaryShared",
  WisdomPointSaved = "wisdomPointSaved",
  WisdomPointRemoved = "wisdomPointRemoved",
  NotificationPreferenceChanged = "notificationPreferenceChanged",
  PushPermissionChanged = "pushPermissionChanged",
  NotificationOpened = "notificationOpened",
  WeeklyRecapViewed = "weeklyRecapViewed",
  WeeklyRecapPosted = "weeklyRecapPosted",
  RegistrationPromptViewed = "registrationPromptViewed",
  RegistrationPromptDismissed = "registrationPromptDismissed",
  ContentCtaClicked = "contentCtaClicked",
  SignInRequested = "signInRequested",
  ConnectorInstallOfferClicked = "connectorInstallOfferClicked",
  ConnectorProOfferOpened = "connectorProOfferOpened",
  /** Key moments started playing (all of them, or from one moment on). */
  KeyMomentsPlayed = "keyMomentsPlayed",
  /** A Pro set of key moments of a chosen length or topic was made. */
  KeyMomentsCustomized = "keyMomentsCustomized",
}

export enum AnalyticsProperty {
  Plan = "plan",
  Source = "source",
  InsightIndex = "insightIndex",
  Focus = "focus",
  Method = "method",
  NotificationType = "notificationType",
  Channel = "channel",
  Placement = "placement",
  Page = "page",
  Store = "store",
  /** Index of the moment playback started from. */
  MomentIndex = "momentIndex",
  Minutes = "minutes",
  HasTopic = "hasTopic",
  /** Offer page A/B test variant the visitor saw. */
  OfferVariant = "offerVariant",
  /** The checkout was started from the offer shown after leaving one. */
  AbandonOffer = "abandonOffer",
}

export enum SummarySource {
  WatchPanel = "watchPanel",
  Popup = "popup",
  Web = "web",
  LandingDemo = "landingDemo",
  Mobile = "mobile",
}

export enum SignInMethod {
  EmailLink = "emailLink",
  EmailOtp = "emailOtp",
  Google = "google",
}

/** Person property holding the email typed into a sign-in form. */
export const SIGN_IN_EMAIL_PERSON_PROPERTY = "email";

export enum ShareMethod {
  Copy = "copy",
  Send = "send",
}

/** How a buyer left the checkout before the abandon offer showed. */
export enum CheckoutLeave {
  /** Closed the checkout opened inside the offer page. */
  Closed = "closed",
  /** Came back from Stripe's own page with its back link. */
  Canceled = "canceled",
}

export enum CheckoutPlan {
  Annual = "annual",
  Monthly = "monthly",
}
